import ComponentWithSocket from '../../../lib/component';
import {Component} from 'vue-property-decorator';

@Component
export default class SlidesManage extends ComponentWithSocket {
    public id: string = '';

    public updateSlide: {
        imageSrc: string;
        image: any;
        url: string;
        position: number;
    } = {
        imageSrc: '',
        image: '',
        url: '',
        position: 1
    };

    public addBtnLoading: boolean = false;
    public updateSlideSuccess: string = '';
    public updateSlideError: string = '';

    constructor() {
        super();
    }

    mounted() {
        this.id = this.$root.$route.params.id;
        this.getSlide();
    }

    async getSlide() {
        await fetch(`${process.env.API2_URL}/slide/${this.id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
            }

            return response.json();
        }).then(data => {
            if (data && data.success) {
                this.updateSlide.imageSrc = data.data.image;
                this.updateSlide.url = data.data.url;
                this.updateSlide.position = data.data.position;
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }

    async updateSlideAction() {
        if (!this.updateSlide.url || !this.updateSlide.position) {
            alert('Te rugam sa completezi toate datele din formular');
            return;
        }

        let payload = {};
        let image: any = '';

        if (this.updateSlide.image) {
            image = await this.convertToBase64(this.updateSlide.image);
            payload = {
                url: this.updateSlide.url,
                position: this.updateSlide.position,
                image: image
            };
        } else {
            payload = {
                url: this.updateSlide.url,
                position: this.updateSlide.position
            };
        }

        this.addBtnLoading = true;

        await fetch(`${process.env.API2_URL}/slide/${this.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
                this.updateSlideError = `Eroare: ${response.status}`;
                this.updateSlideSuccess = '';
            }

            this.addBtnLoading = false;

            return response.json();
        }).then(data => {
            if (data && data.success) {
                this.updateSlideSuccess = data.message;
                this.updateSlideError = '';
            } else {
                this.updateSlideError = data.message;
                this.updateSlideSuccess = '';
            }

            this.addBtnLoading = false;
        }).catch(error => {
            console.error('Error:', error);
            this.updateSlideError = error;
            this.updateSlideSuccess = '';
            this.addBtnLoading = false;
        });
    }

    convertToBase64(image: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                if (!e.target) {
                    reject(new Error('No target'));
                    return;
                }

                resolve(e.target.result);
            };

            reader.onerror = error => {
                reject(error);
            };

            reader.readAsDataURL(image);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/slides/manage/index.ts